import { computed } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import useModal from '@src/utils/hooks/use-modal';
import FooterModalStore from '@src/business-components/footer-modal/store';
import { pageSwiperEffect } from '@src/components/swiper/page-swiper/config';
import PageSwiperStore from '@src/components/swiper/page-swiper/store';
import FooterModal from '@src/business-components/footer-modal';
import NavibarStore from '@src/business-components/navibar/store';

// 最后一个 slide 的索引（下载安装页）
const LAST_SLIDE_INDEX = 2;
// "关注我们"虚拟导航项的索引
const FOLLOW_NAV_INDEX = 3;

class MainStore extends BaseStore {
  // 页面滑动切换
  pageSwiperStore = new PageSwiperStore({
    effectMode: pageSwiperEffect.NORMAL,
    onPageSwiperChange: activeIndex => {
      this.navibarStore.isSticky = activeIndex > 0;
      // 如果不是最后一页，直接更新 activeIndex
      // 如果是最后一页，需要根据滚动位置判断是"下载安装"还是"关注我们"
      if (activeIndex !== LAST_SLIDE_INDEX) {
        this.navibarStore.activeIndex = activeIndex;
      }
    },
    // 最后一页滚动到底部时的回调
    onLastSlideScrollToBottom: isAtBottom => {
      if (this.pageSwiperStore.baseSwiperStore.activeIndex === LAST_SLIDE_INDEX) {
        this.navibarStore.activeIndex = isAtBottom ? FOLLOW_NAV_INDEX : LAST_SLIDE_INDEX;
      }
    }
  });
  // 导航栏
  navibarStore = new NavibarStore({
    onNavActiveChange: (navItem, index) => {
      const swiper = this.pageSwiperStore.baseSwiperStore.nativeSwiper;

      // 确保 swiper 和 slides 已初始化
      if (!swiper?.slides?.length) return;

      // 点击"关注我们"：先切换到最后一页，再滚动到底部
      if (navItem?.isVirtual && index === FOLLOW_NAV_INDEX) {
        swiper.slideTo(LAST_SLIDE_INDEX, 0);
        // 滚动到最后一页底部
        setTimeout(() => {
          const activeSlide = swiper?.slides?.[LAST_SLIDE_INDEX];
          if (activeSlide) {
            activeSlide.scrollTo({ top: activeSlide.scrollHeight, behavior: 'smooth' });
          }
        }, 100);
      } else {
        swiper.slideTo(index, 0);
        // 切换到其他页时，重置滚动位置到顶部
        setTimeout(() => {
          const activeSlide = swiper?.slides?.[index];
          if (activeSlide) {
            activeSlide.scrollTop = 0;
          }
        }, 100);
      }
    }
  });
  // 底部版权弹窗
  footerModalStore = new FooterModalStore({
    clickBacktopCallback: () => {
      const swiper = this.pageSwiperStore.baseSwiperStore.nativeSwiper;
      swiper?.slideTo(0, 0);
    }
  });
  // 当前激活的页面索引
  @computed
  get activeIndex() {
    return this.pageSwiperStore.baseSwiperStore.activeIndex;
  }

  use() {
    super.use();

    this.footerModal = useModal(FooterModal, {
      store: this.footerModalStore
    });
  }
}

export default MainStore;
